function ViewAuditHistory() {

    // Define the function which we call further down....
    function doProcess() {

        var tableName = "";
        if (window["myTable"] !== undefined) {
            tableName = window["myTable"];
        }

        var screen = "";
        if (window["auditFilterScreen"] !== undefined) {
            screen = window["auditFilterScreen"];
        }

        var control = "";
        if (window["auditFilterControl"] !== undefined) {
            control = window["auditFilterControl"];
        }

        // this screen has no active recordID, shortcut the call here and supply the empty GUID
        // this table is the only one that makes use of the screen and control parameters
        // which default to null for all other calls (i.e. optional params)
        if (tableName == "SecurityGroupFieldLinks") {
            app.openWindow({
                title: ___('VIEW_AUDIT_LOG_HISTORY'),
                url: '/Auditing/ViewLog/?table=' + tableName + '&uid=00000000-0000-0000-0000-000000000000&screen=' + screen + '&control=' + control
            });

            return;
        }

        // Try to get the record id.
        if (window["recordID"] === undefined) {
            // This is a neat little trick to detect whether or not
            // a global variable has been defined on the page.
            // So if there is no recordID, that means this is a one-off page
            // and we'll need to handle it special anyway. So throw an error.

            // TODO: System Defaults, Manage Data Check Scripts, Recall Escalation and Calendar windows need to be specially handled!!
            return;
        }

        // Now get the recordID and then pass it off to the audit log
        // viewer.
        var recordID = window["recordID"];

        // table name contains a space!
        if ((tableName) && (tableName.indexOf(" ") > 0 ||
            tableName.toLowerCase() == 'callsheet' ||
            tableName.toLowerCase() == 'alerting'))  // MTM-3109, MTM-3123 one hack leads to another, I want to throw out the whole myTable thing, but...
        {
            tableName = "";
        }

        // window["myTable"] may be blank!
        // test again instead of else() branch
        if (!(tableName)) {

            // try to derive it.
            var uri = window.location.toString();

            if (uri.trim().toLowerCase().startsWith("https:"))
                uri = uri.replace("https://", "");
            else
                uri = uri.replace("http://", "");
            uri = uri.substr(uri.indexOf('/') + 1);
            uri = uri.substr(0, uri.indexOf('/'));

            if (uri.toLowerCase() == "pricing") {
                tableName = "Pricing";
            }
            else if (uri.toLowerCase() == "addresses") {
                tableName = "Addresses";
            }
            else if (uri.toLowerCase() == "alerting") {
                if (window.location.toString().toLowerCase().indexOf('getparameters') != -1) {
                    tableName = "AlertParameters";
                }
                else if (window.location.toString().toLowerCase().indexOf('editschedule') != -1) {
                    tableName = "AlertEvents";
                }
            }
            // singularize the uri.
            else if (uri[uri.length - 1] == "y") {
                // Ends in y
                tableName = uri.substr(0, uri.length - 1) + "ies";
            } else {
                tableName = uri + "s";
            }
        }

        // MTM-3838
        // another special case, yay!
        // we want the currently selected TA record in the grid
        if (tableName == 'ToolAssignments') {
            recordID = window["lastToolId"];
        }

        //MTM-8808 Record ID verification moved here as for the ToolAssignment screen the recordID is getting populted with the correct value in the above step
        if (recordID === undefined || recordID === null || recordID.length == 0 || recordID.toLowerCase() == '4ca22a04-0079-4033-84a5-e5968c7f3f17') // MTM-7919
            return;

        // Pop up the history box.
        app.openWindow({
            title: ___('VIEW_AUDIT_LOG_HISTORY'),
            url: '/Auditing/ViewLog/?table=' + tableName + '&uid=' + recordID
        });

    }

    // Check if change tracking is enabled.
    var doChangeTracking = (window["changeTrackingEnabled"] || window.parent["changeTrackingEnabled"] || false).toString();
    if (doChangeTracking == 'false') {
        app.showAlert("Attention", ___('SYSTEM_DEFAULT_CHANGE_TRACKING_OFF'));    //, doProcess);
    } else { doProcess(); }

};